// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"302":"0e41661d7c60b1b7","487":"b418d2888bdfebe7","868":"9bf3a323d2c08ac7","921":"7e270ae1d0049d66"}[chunkId] + ".js";
};